import { services } from '../../services';
var action = "manage/invoice/";

export const invoiceService = {
    getList,
    getOne,
    voidInvoice
};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}detail/${id}`, 'GET');
}

function voidInvoice(object) {
    return services.restApi(`${action}void`, 'POST', object);
}
